import { Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import LinearProgress, {
    linearProgressClasses
} from "@mui/material/LinearProgress";

// The Material UI "progress bar" is dynamically rendered based on the value of the supplied field
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 20,
    width: 300,
    borderRadius: 5,
    marginRight: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor:
            theme.palette.grey[theme.palette.mode === "light" ? 200 : 800]
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        background: "linear-gradient(90deg, rgba(253,244,150,1) 0%, rgba(52,179,51,1) 100%)"
    }
}));

export default function ProgressBar({ header, value }: any) {
    return (
        <Box sx={{ width: '400px', height: '45px' }}>
            <Typography variant="h6" sx={{ color: "white", textAlign: 'center' }}>
                {header}
            </Typography>
            <Box display='flex' flexDirection='row' justifyContent='space-evenly'>
                <BorderLinearProgress variant="determinate" value={value} />
                <Typography variant="h6" sx={{ color: "white", textAlign: 'center' }}>
                    {value + '%'}
                </Typography>
            </Box >
        </Box >
    );
}